'use strict';

(function (global) {
  /**
   * Абстрактный класс элемента страницы.
   *
   * @extends BaseObject
   * @abstract
   * @since 5.6.0.1300
   */
  var AbstractBasePageElement = BaseObject.extend({

    /**
     * Конструктор.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#init
     * @override
     * @see BaseObject#init
     */
    init: function () {
      this._super();
    },

    /**
     * Имя класса.
     *
     * @private
     * @property WebAccess.components.wrappers.AbstractBasePageElement#className
     * @override
     * @see BaseObject#className
     */
    className: 'AbstractBasePageElement',

    /**
     * jQuery-селектор элемента страницы.
     *
     * @private
     * @property AbstractBasePageElement#selector
     * @deprecated since 5.6.
     */
    selector: '',

    /**
     * Сообщение об ошибке при обращении к абстрактному методу.
     *
     * @private
     * @property WebAccess.components.wrappers.AbstractBasePageElement#_errorMessage
     */
    _errorMessage: 'Calling method of abstract class is not allowed.',

    /**
     * Признак скрытого элемента страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#isHidden
     * @return {boolean} True, если элемент скрыт, иначе False.
     */
    isHidden: function () {
      console.error(this._errorMessage);
      return false;
    },

    /**
     * Признак доступного для изменения элемента страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#isEnabled
     * @return {boolean} True, если элемент отображается, иначе False.
     */
    isEnabled: function () {
      console.error(this._errorMessage);
      return true;
    },

    /**
     * Признак выбора элемента страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#isSelected
     * @return {boolean} True, если элемент выбран, иначе False.
     */
    isSelected: function() {
      console.error(this._errorMessage);
      return false;
    },

    /**
     * Отображает элемент страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#show
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    show: function () {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Скрывает элемент страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#hide
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    hide: function () {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Устанавливает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#setLabel
     * @param {string} text Заголовок элемента страницы.
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    setLabel: function (text) {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Получает заголовок элемента страницы.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#getLabel
     * @return {string} Заголовок элемента страницы.
     */
    getLabel: function () {
      console.error(this._errorMessage);
      return '';
    },

    /**
     * Устанавливает всплывающую подсказку.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#setTooltip
     * @param {string} text Текст всплывающей подсказки.
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     *
     */
    setTooltip: function (text) {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Получает текст всплывающей подсказки.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#getTooltip
     * @return {string} Текст всплывающей подсказки.
     */
    getTooltip: function () {
      console.error(this._errorMessage);
      return '';
    },

    /**
     * Устанавливает иконку.
     *
     * Иконку необходимо разместить в папке проекта App_Sprites и после скомпилировать проект.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#setIcon
     * @param {string} path Путь к иконке.
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     *
     * @example
     * WebAccess.current.sideBar.tabs.create("FilterRRCAssignment1")
     *          .enable().setLabel(L("RRC_ASSIGNMENTS_FILTER"))
     *          .setIcon("SidebarAndExtensions/EDocumentSearch_24.png") 
     *
     * WebAccess.current.sideBar.tabs.create("FilterRRCAssignment1")
     *          .enable()
     *          .setLabel(L("RRC_ASSIGNMENTS_FILTER"))
     *          .setIcon("/App_Sprites/SidebarAndExtensions/EDocumentSearch_24.png") 
     */
    setIcon: function (path) {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Получает имя иконки.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#getIcon
     * @return {string} Имя иконки.
     */
    getIcon: function () {
      console.error(this._errorMessage);
      return '';
    },

    /**
     * Имитировать щелчок мыши.
     * Имитация щелчка мыши по элементу страницы либо установка обработчика на событие onClick, если передан opt_callback.
     * Заменяет обработчик, установленный по умолчанию. Используется в прикладной разработке.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#click
     * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по элементу.
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     *
     * @example
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click();
     * WebAccess.current.toolBar.buttons.CrtRefRecords.click(function() {
     *  alert("Существующие обработчки событий click были перезаписаны данным");
     * })
     */
    click: function (opt_callback) {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Делает элемент страницы недоступным для изменения.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#disable
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    disable: function () {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Делает элемент страницы доступным для изменения.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#enable
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    enable: function () {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Отмечает элемент страницы.
     * Например, отображает кнопку как нажатую.
	 *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#select
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     *
     */
    select: function () {
      console.error(this._errorMessage);
      return this;
    },

    /**
     * Снимает отметку с элемента страницы.
	 * Например, отображает кнопку как ненажатую.
     *
     * @method WebAccess.components.wrappers.AbstractBasePageElement#unSelect
     * @return {WebAccess.components.wrappers.AbstractBasePageElement} Объект типа AbstractBasePageElement.
     */
    unSelect: function () {
      console.error(this._errorMessage);
      return this;
    }
  }, {
    EVENT: {
      // Событие срабатывает при изменении модели элемента.
      CHANGE: 'change',
      // Событие срабатывает, когда элемент становится недоступным для изменения.
      DISABLE: 'disable',
      // Событие срабатывает, когда элемент становится доступным для изменения.
      ENABLE: 'enable',
      // Событие срабатывает, когда элемент становится невидимым.
      HIDE: 'hide',
      // Событие срабатывает, когда элемент становится видимым.
      SHOW: 'show'
    }
  });

  global.AbstractBasePageElement = AbstractBasePageElement;
})(window.WebAccess.components.wrappers);